import styled from "styled-components";

export const EmployeesWrapper = styled("div")(() => {
  return {
    position: "relative",
    padding: 0,
    display: "grid",
    gap: "1.5rem",
    "& .add-employee-modal": {
      position: "fixed",
      height: "auto",
      width: "auto",
      maxWidth: "250px",
      zIndex: 1000,
      backgroundColor: "var(--color-background)",
      borderRadius: "0.5rem",
      boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
    },
    "& .employee-bulk-upload-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--color-neutral)",
      borderRadius: "1rem",
      boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
      "@media screen and (max-width: 768px)": {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "var(--color-neutral)",
        borderRadius: "1rem",
        boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
        width: "80%",
      },
    },
    "& .error-text": {
      margin: "0.2rem 0 0",
      color: "#B91C1C",
      fontFamily: "Poppins",
      fontWeight: 500,
      fontSize: "0.88rem",
    },
    "& .delete-employee-success-modal": {
      position: "fixed",
      top: "var(--topNavHeight)",
      left: 0,
      width: "100vw !important",
      height: "auto !important",
      overflow: "visible",
      boxShadow: "none !important",
      zIndex: 100,
      "@media screen and (min-width: 1024px)": {
        left: "var(--sideNavWidth)",
        width: "calc(100vw - var(--sideNavWidth)) !important",
      },
    },
    "& .delete-employee-success-modal > div": {
      position: "fixed !important",
      top: "calc(var(--topNavHeight) + ((100vh - var(--topNavHeight)) * 0.42)) !important",
      left: "50vw !important",
      transform: "translate(-50%, -50%) !important",
      width: "min(520px, calc(100% - 32px))",
      maxWidth: "520px",
      margin: 0,
      backgroundColor: "var(--color-background) !important",
      padding: "var(--cardPadding) !important",
      borderRadius: "24px !important",
      boxShadow: "0 24px 60px rgba(41, 49, 112, 0.2) !important",
      border: "1px solid rgba(78, 87, 187, 0.12) !important",
      overflow: "hidden !important",
      "@media screen and (min-width: 1024px)": {
        left: "calc(var(--sideNavWidth) + ((100vw - var(--sideNavWidth)) / 2)) !important",
      },
    },
    "& .delete-employee-success-modal .icon-box": {
      display: "flex",
      justifyContent: "center",
      marginBottom: "12px",
    },
    "& .delete-employee-success-modal .title-box h1": {
      margin: "0 0 10px",
      textAlign: "center",
      color: "var(--color-text)",
      fontSize: "34px",
    },
    "& .delete-employee-success-modal .message-box p": {
      margin: "0 0 24px",
      textAlign: "center",
      color: "var(--color-text-light)",
      lineHeight: 1.7,
      fontSize: "18px",
    },
    "& .delete-employee-success-modal .call-to-action-button-box": {
      display: "flex",
      justifyContent: "center",
    },
    "& .delete-employee-success-modal .call-to-action-button-box button": {
      backgroundColor: "var(--color-primary) !important",
      background: "var(--color-primary) !important",
      color: "var(--color-background) !important",
      width: "fit-content",
      minWidth: "140px",
      padding: "0.75rem 1rem",
      borderRadius: ".5rem",
      boxShadow: "0 14px 28px rgba(78, 87, 187, 0.2)",
      border: "none !important",
    },
    "& .delete-employee-success-modal .call-to-action-button-box button span": {
      color: "#FFFFFF !important",
    },
  };
});
export const FiltersCard = styled("section")(() => {
  return {
    border: "1px solid #e5e7eb",
    borderRadius: "0.85rem",
    backgroundColor: "var(--color-primary-hover)",
    padding: "1rem",
    display: "grid",
    gap: "1rem",
    "& select, & input": {
      padding: "0.7rem 0.8rem",
      borderRadius: "0.45rem",
      border: "1px solid #d9dee7",
      fontWeight: "400",
      color: "var(--color-text)",
      backgroundColor: "var(--color-neutral)",
      "&:focus": {
        outline: "none",
        border: "none",
      },
    },
    "& fieldset": {
      flex: 1,
      overflow: "hidden",
    },
    "& label": {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "var(--color-primary)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      marginBottom: "0.45rem",
      display: "inline-block",
    },
    "& .filter-title": {
      margin: 0,
      display: "inline-flex",
      alignItems: "center",
      gap: "0.45rem",
      fontFamily: "Poppins",
      color: "var(--color-text-light)",
      fontSize: "0.78rem",
      letterSpacing: "0.07em",
      textTransform: "uppercase",
      fontWeight: 700,
    },
    "& .filters-grid": {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gap: "0.9rem",
      alignItems: "end",
    },
    "@media screen and (max-width: 1024px)": {
      "& .filters-grid": {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
    },
    "@media screen and (max-width: 640px)": {
      padding: "0.75rem",
      "& .filters-grid": {
        gridTemplateColumns: "1fr",
      },
    },
  };
});

export const EmployeeTableCard = styled("div")(() => {
  return {
    border: "1px solid #e5e7eb",
    borderRadius: "0.9rem",
    overflowX: "auto",
    backgroundColor: "var(--color-neutral)",
    "& .employee-grid": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "950px",
    },
    "& .employee-grid th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& .employee-grid td": {
      border: "none",
      borderBottom: "1px solid #edf1f6",
      color: "var(--color-text)",
      padding: "0.95rem 1rem",
      minWidth: "unset",
      fontSize: "0.88rem",
      verticalAlign: "middle",
      position: "relative",
    },
    "& .employee-cell": {
      display: "flex",
      alignItems: "center",
      gap: "0.65rem",
    },
    "& .avatar": {
      width: "34px",
      height: "34px",
      borderRadius: "50%",
      background:
        "linear-gradient(135deg, var(--color-tertiary) 0%, var(--color-tertiary) 50%, var(--color-secondary) 100%)",
      color: "#FFFFFF",
      fontSize: "0.72rem",
      fontWeight: 700,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    "& .employee-meta": {
      display: "grid",
      gap: "0.15rem",
      minWidth: 0,
    },
    "& .employee-name": {
      fontWeight: 600,
      fontSize: "0.95rem",
      color: "var(--color-text)",
    },
    "& .employee-email": {
      color: "var(--color-text-light)",
      fontSize: "0.8rem",
      maxWidth: "200px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& .department-tag": {
      display: "inline-flex",
      alignItems: "center",
      padding: "0.2rem 0.55rem",
      borderRadius: "999px",
      fontWeight: 700,
      fontSize: "0.75rem",
      letterSpacing: "0.03em",
      textTransform: "uppercase",
      width: "fit-content",
    },
    "& .salary": {
      fontWeight: 700,
      color: "var(--color-text)",
      fontSize: "0.75rem",
    },
    "& .role": {
      color: "var(--color-text-light)",
      fontWeight: 500,
      fontSize: "0.8rem",
    },
    "& .action-cell": {
      textAlign: "center",
      width: "72px",
      cursor: "pointer",
    },
    "& .action-trigger": {
      color: "var(--color-text-light)",
      padding: "0.4rem",
      borderRadius: "0.45rem",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "& .action-trigger:hover": {
      backgroundColor: "#f7f8fa",
    },
    "& .action-dropdown": {
      position: "absolute",
      top: "100%",
      right: 0,
      marginTop: "0.5rem",
      backgroundColor: "var(--color-neutral)",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      minWidth: "150px",
      zIndex: 1000,
      listStyle: "none",
      margin: 0,
      padding: 0,
      overflow: "hidden",
    },
    "& .action-dropdown li": {
      padding: "0.5rem 0.8rem",
      fontSize: "0.82rem",
      color: "var(--color-text)",
      cursor: "pointer",
    },
    "& .action-dropdown li:hover": {
      backgroundColor: "var(--color-button-secondary-hover)",
      color: "var(--color-text-light)",
    },
    "& .table-footer": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0.8rem 1rem",
      gap: "0.8rem",
      flexWrap: "wrap",
      color: "var(--color-text-light)",
      fontFamily: "Poppins",
      fontSize: "0.8rem",
    },
    "& .pagination": {
      display: "inline-flex",
      gap: "0.45rem",
      alignItems: "center",
    },
    "& .page-chip": {
      appearance: "none",
      width: "1.7rem",
      height: "1.7rem",
      border: "1px solid #d9dee7",
      borderRadius: "0.35rem",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "var(--color-text-light)",
      fontWeight: 600,
      backgroundColor: "var(--color-neutral)",
      cursor: "pointer",
      padding: 0,
    },
    "& .page-chip.active": {
      backgroundColor: "var(--color-primary)",
      color: "#ffffff",
      borderColor: "var(--color-primary)",
    },
    "& .page-chip:disabled": {
      opacity: 0.45,
      cursor: "not-allowed",
    },
  };
});
